import { Typography } from "@mui/material";

interface CheckboxLabelProps {
  primaryText: string;
  subtitle: string;
}

const CheckboxLabel: React.FC<CheckboxLabelProps> = ({
  primaryText,
  subtitle,
}) => {
  return (
    <div>
      <Typography variant="subtitle1">{primaryText}</Typography>
      <Typography variant="caption">{subtitle}</Typography>
    </div>
  );
};

export default CheckboxLabel;
